module.exports = __webpack_public_path__ + "img/neotag-background.a56d1102.jpg";